/** Шаринг. */
import type { EndpointDef } from "../endpoint";
import { PosInt, UInt } from "../../common";
import { z } from "zod";

/** Шаринг: в чат (`savePreparedInlineMessage`) или в сторис (`shareToStory`). */
export const ShareRequest = z.object({
  target: z.enum(["chat", "story"]),
  /** Что показать на картинке «I crushed N zombies». */
  wave: PosInt,
  kills: UInt,
});

export const ShareResponse = z.object({
  /** Для `chat`: id подготовленного сообщения для `Telegram.WebApp.shareMessage`. */
  preparedMessageId: z.string().nullable(),
  /** Картинка (для сторис и предпросмотра), абсолютный https URL. */
  imageUrl: z.url(),
  /** Параметр `startapp`, с которым друг попадёт сразу в бой. */
  startParam: z.string().max(64),
});

export const shareEndpoints = {
  /** Подготовить шаринг. */
  share: { method: "POST", path: "/api/share", request: ShareRequest, response: ShareResponse, auth: true },
} as const satisfies Record<string, EndpointDef>;
